import { MapfreCardComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnChanges } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreCardComponent],
  selector: 'app-profile',
  templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnChanges {
  loading: boolean;
  onPasswordEdit: boolean;
  additionalClass;
  subscription: Subscription;

  constructor(
    private router: Router
  ) {
    this.subscription = this.router.events.subscribe((event) => {
      this.additionalClass = "";
      if (event instanceof NavigationEnd) {
        if (event.url == '/profile/enter-password' || event.url == '/profile/edit-password') {
          this.additionalClass = "password-container"
        }
      }
    });
  }

  onPasswordEditUrl() {
    this.additionalClass = "";
    if (this.router.url === '/profile/enter-password') {
      this.onPasswordEdit = true;
      this.additionalClass = "password-container"
    }
  }
  ngOnChanges(): void {
    this.onPasswordEditUrl();
  }
}
